import React, { useEffect } from 'react';
import './campos-item-carrossel.component.scss';
import { Button, FormControlLabel, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { ItemMenusModel, ItensComIconesModel } from '../../models/footer.model';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { CONSTANTS } from '../../constants/constants';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import { ItensCarrossel } from '../../models/carrossel.model';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';

type CamposItemCarrosselComponentProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  itemCarrossel?: ItensCarrossel;
  index?: number;
}

function CamposItemCarrosselComponent(props: CamposItemCarrosselComponentProps) {

  const [tituloInput, setTituloInput] = React.useState(props.itemCarrossel ? props.itemCarrossel.titulo : '');
  const [descricaoInput, setDescricaoInput] = React.useState(props.itemCarrossel ? props.itemCarrossel.descricao : '');
  const [imagemInput, setImagemInput] = React.useState(props.itemCarrossel ? props.itemCarrossel.imagem : '');
  const [imagemMobileInput, setImagemMobileInput] = React.useState(props.itemCarrossel ? props.itemCarrossel.imagem_mobile : '');

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      id: props.itemCarrossel?.id,
      titulo: tituloInput,
      descricao: descricaoInput,
      imagem: imagemInput,
      imagem_mobile: imagemMobileInput
    });
  };

  return (
    <section className="campos-item-carrossel">
      <div className="campo w50">
        <TextField value={tituloInput} label="Título" onChange={(event) => setTituloInput(event.target.value)} />
      </div>

      <div className="campo w50">
        <TextField value={descricaoInput} label="Descrição" onChange={(event) => setDescricaoInput(event.target.value)} />
      </div>

      <div className="campo w50">
        <AttachmentModalComponent setVal={(attachFile) => setImagemInput(attachFile.src)} file={{id: '', src: imagemInput}} legenda='Imagem' />
      </div>

      <div className="campo w50">
        <AttachmentModalComponent setVal={(attachFile) => setImagemMobileInput(attachFile.src)} file={{id: '', src: imagemMobileInput}} legenda='Imagem mobile' />
      </div>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.itemCarrossel?.id)}><DeleteIcon /> Remover item</Button>
      </div>
    </section>
  );
}

export default CamposItemCarrosselComponent;
